import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as message from "../../../config/CommonMessages";
import { Link } from "react-router-dom";
import { Close, Clear } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import NumericInput from "react-numeric-input";
import * as code from "./../../../config/Constants";

import {
  getAllBillingItems,
  addBillingPlan,
  getApplicationData,
} from "../../../actions/BillingActions";

function BillingPlanForm({
  addBillingPlan,
  getAllBillingItems,
  getApplicationData,
}) {
  const initialState = {
    ApplicationName: process.env.REACT_APP_APPLICATION_NAME,
    PlanName: "",
    chargesPerError: false,
    ChargesPer: 0,
  };

  const history = useHistory();
  const [form, setForm] = useState(initialState);
  const [render, setRender] = useState(false);
  const [currentSelect, setcurrentSelect] = useState("");
  const [billingItems, setBillingItems] = useState([]);
  const [selecetedItems, setSelecetedItems] = useState([]);
  //const [errorsindex, setErrorsindex] = useState();
  const [errors, setErrors] = useState({});
  const [disable, setDisable] = useState(false);
  const [inputFields, setInputFields] = useState([]);
  const [applicationdata, setApplicationdata] = useState([]);
  const [billinPlanduplicat, setBillinPlanduplicat] = useState(false);

  useEffect(() => {
    getallBillingitems();
    getapplicationData();
  }, [render]);

  function getallBillingitems() {
    //let filterdata;
    getAllBillingItems().then((result) => {
      if (Array.isArray(result.data) && result.data.length > 0) {
        let filterdata = result.data.filter((item) => item.Isactive === true);
        setBillingItems(filterdata);
      } else {
        setBillingItems([]);
      }
    });
  }
  function getapplicationData() {
    getApplicationData().then((result) => {
      Array.isArray(result.data) && result.data.length > 0
        ? setApplicationdata(result.data)
        : setApplicationdata([]);
    });
  }

  const findFormErrors = () => {
    const { ApplicationName, PlanName, chargesPerError } = form;
    const newErrors = {};
    // ApplicationName errors
    if (!ApplicationName || ApplicationName.trim() === "") {
      newErrors.ApplicationName = message.ENTER_APPLICATION_NAME;
    }

    //charges per error
    if (chargesPerError === true) {
      newErrors.chargesPerError = message.CHARGES_PER_NOT_ZERO;
    }

    // plan name errors
    if (!PlanName || PlanName.trim() === "") {
      newErrors.PlanName = message.ENTER_PlAN_NAME;
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // get our new errors
    const newErrors = findFormErrors();
    // Conditional logic:
    if (Object.keys(newErrors).length > 0) {
      // We got errors!
      setErrors(newErrors);
    } else {
      // No errors! Put any logic here for the form submission!
      form.ApplicationName.trim();
      form.PlanName.trim();
      let data = {
        inputFields: inputFields,
        ApplicationName: form.ApplicationName.trim(),
        ApplicationId: applicationdata[0].billingApplicationId,
        PlanName: form.PlanName.trim(),
        isActive: true,
        isDefault: false,
      };
      addBillingPlans(data);
    }
  };

  function addBillingPlans(values) {
    addBillingPlan(values)
      .then((res) => {
        if (res.status === code.OK) {
          history.push({
            pathname: "/BillingModule/BillingPlansList",
          });
        } else {
          if (res.data === "duplicate") {
            setBillinPlanduplicat(true);
          }
        }
      })
      .catch((err) => {});
  }

  const handleFormChange = (index, event, id, name, billingItemCode) => {
    let data = [...inputFields];
    data[index][name] = event;
    // data[index]["billingItemId"] = id;
    // data[index]["billingItemName"] = billingItemCode;
    // data[index]["billingItemDesc"] = billingItemDesc;
    let flag = true;
    // 23-11-2023 , commenting this code , because now we do not need to show error on percharge 0.
    // for (let input of data) {
    //   if (input.perCharge === 0) {
    //     flag = false;
    //     break;
    //   }
    // }
    // if (flag === true) {
    //   setField("chargesPerError", false);
    // }
    // 23-11-2023 , commenting this code , because now we do not need to show error on percharge 0.
    //(&& billingItemCode != "basicfees") this condition is for basicfees.basicfees can became zero so do not show error and with zero we can save it
    // if (
    //   name === "perCharge" &&
    //   event === 0 &&
    //   billingItemCode !== "basicfees"
    // ) {
    //   setField("chargesPerError", true);
    // }
    setInputFields(data);
  };

  const handleSelectitemsChange = (event) => {
    if (
      billingItems &&
      billingItems.length > 0 &&
      currentSelect !== "" &&
      event !== ""
    ) {
      let result = billingItems.find((item) => item._id === event);
      // this condition for if item present in input feild we have to check it is present or not , if present do not append again.
      let findResultofInputFeild;
      if (inputFields.length > 0) {
        findResultofInputFeild = inputFields.find(
          (value) => value.billingItemId === event
        );
      } else {
        findResultofInputFeild = undefined;
      }
      if (result !== undefined && findResultofInputFeild === undefined) {
        if (inputFields.length > 0) {
          let flag = true;
          //checking last input is zero or not . if zero do not append new billing item.
          // for (let input of inputFields) {
          // if last input is Basic Fees,so it can be zero, hence we have to append new feild
          //so this and condition is for,do not check percharge for basicfees
          //commenting tjis , now we do not need to validate on price zero.
          //   if (
          //     input.perCharge === 0 &&
          //     input.billingItemName !== "basicfees"
          //   ) {
          //     flag = false;
          //     break;
          //   }
          // }
          if (flag === true) {
            setSelecetedItems([...selecetedItems, result]);
            let newfield = {
              billingItemId: result._id,
              freeCount: 0,
              perCharge: 0,
              billingItemName: result.billingItemCode,
              itemIsactive: true,
              billingItemDesc: result.billingItemDesc,
              Isroleitem: result.Isroleitem,
            };
            setInputFields([...inputFields, newfield]);
            setcurrentSelect("");
            //if results billingItemCode == "basicfees" so we have to make setField("chargesPerError", false). so that one empty plan with basic fees zero can be made.
            if (result.billingItemCode === "basicfees") {
              setField("chargesPerError", false);
            }
            //  else {
            //   setField("chargesPerError", true);
            // }
          }
        } else {
          setSelecetedItems([...selecetedItems, result]);
          let newfield = {
            billingItemId: result._id,
            freeCount: 0,
            perCharge: 0,
            billingItemName: result.billingItemCode,
            itemIsactive: true,
            billingItemDesc: result.billingItemDesc,
            Isroleitem: result.Isroleitem,
          };
          setInputFields([...inputFields, newfield]);
          setcurrentSelect("");

          //if results billingItemCode == "basicfees" so we have to make setField("chargesPerError", false). so that one empty plan with basic fees zero can be made.
          if (result.billingItemCode === "basicfees") {
            setField("chargesPerError", false);
          }
        }
      }
    }
  };
  const handledeleteSelectItems = (event, inputfeildindex) => {
    //this condition for when value is zero but row is deleted , hence we have to clear validation.
    if (inputFields[inputfeildindex].perCharge === 0) {
      setField("chargesPerError", false);
    }
    // this condition is for when we have only one row and we delete so error should show.
    //commenting this , now we do not need to make validation on price.
    // if (inputFields.length === 1) {
    //   setField("chargesPerError", true);
    // }
    let array = selecetedItems;
    let index = -1;
    for (const e of array) {
      index++;
      if (e._id === event) {
        break;
      }
    }
    if (index !== -1) {
      array.splice(index, 1);
      setSelecetedItems(array);
      let data = [...inputFields];
      data.splice(inputfeildindex, 1);
      setInputFields(data);
      setRender(!render);
    }
  };

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
    // Check and see if errors exist, and remove them from the error object:
    if (!!errors[field]) {
      setErrors({
        ...errors,
        [field]: null,
      });
    }
  };
  return (
    <>
      <div className="step-progress transaction-create">
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
          <Col xs={12} sm={3}>
            <h4 className="title-med mt-0 pt-1">Add Plan</h4>
          </Col>

          <Col xs={12} sm={6} />

          <Col xs={12} sm={3} align="right" className="transaction-close">
            <Link
              to="/BillingModule/BillingPlansList"
              className="nav-link p-0 color-black"
            >
              <Close
                style={{ stroke: "#fff", height: "40px", width: "40px" }}
              />
            </Link>
          </Col>
        </Row>
        <div className="multi-step multi-step-admin">
          <div className="admin-steps admin-content-area">
            <div className="container-custom">
              <Form className="form-sm form-admin" onSubmit={handleSubmit}>
                <Row>
                  <Col md={12}>
                    <h3 className="title-small font-600 mt-2 mb-3 pt-3">
                      Billing Plan Details
                    </h3>
                    <Row>
                      <Col xs={12} sm={6}>
                        <Form.Group>
                          <Form.Label>Application name</Form.Label>
                          <Form.Control
                            type="text"
                            name="ApplicationName"
                            value={form.ApplicationName}
                            onChange={(e) =>
                              setField("ApplicationName", e.target.value)
                            }
                            isInvalid={!!errors.ApplicationName}
                            readOnly
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.ApplicationName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} sm={6}>
                        <Form.Group>
                          <Form.Label>Plan name</Form.Label>
                          <Form.Control
                            type="text"
                            name="PlanName"
                            value={form.PlanName}
                            onChange={(e) =>
                              setField("PlanName", e.target.value)
                            }
                            isInvalid={!!errors.PlanName}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.PlanName}
                          </Form.Control.Feedback>
                          {billinPlanduplicat ? (
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              Billing plan name is duplicate
                            </div>
                          ) : (
                            ""
                          )}
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={3}>
                        <Form.Group>
                          <Form.Label>Billing Items</Form.Label>
                          <select
                            className="form-control"
                            onChange={(e) => {
                              setcurrentSelect(e.target.value);
                            }}
                          >
                            <option value="">Open this select menu</option>
                            {billingItems &&
                              billingItems.map((item) => {
                                return (
                                  <option key={item._id} value={item._id}>
                                    {item.billingItemDesc}
                                  </option>
                                );
                              })}
                          </select>
                        </Form.Group>
                        {inputFields.length === 0 &&
                        Object.keys(errors).length !== 0 ? (
                          <p style={{ color: "red" }}>
                            Please enter billing items
                          </p>
                        ) : (
                          ""
                        )}
                      </Col>

                      <Col xs={12} sm={3}>
                        <Form.Group>
                          <Button
                            type="button"
                            onClick={() =>
                              handleSelectitemsChange(currentSelect)
                            }
                            variant="primary"
                            className="btn-blue btn-head ml-2"
                            style={{ marginRight: "19px", marginTop: "25px" }}
                          >
                            ADD
                          </Button>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={3} />
                    </Row>

                    {selecetedItems && selecetedItems.length > 0
                      ? selecetedItems.map((item, index) => {
                          return (
                            <div>
                              <Row>
                                <Col xs={12} sm={3}>
                                  {index === 0 ? (
                                    <Form.Label>Billing Item Name</Form.Label>
                                  ) : (
                                    <Form.Label />
                                  )}
                                  <Form.Control
                                    type="text"
                                    name="PlanName"
                                    value={item.billingItemDesc}
                                  />
                                </Col>
                                <Col xs={12} sm={3}>
                                  {index === 0 ? (
                                    <Form.Label>Free Count</Form.Label>
                                  ) : (
                                    <Form.Label />
                                  )}

                                  <NumericInput
                                    name="freeCount"
                                    inputMode="numeric"
                                    min={0}
                                    max={99999}
                                    strict
                                    style={false}
                                    value={inputFields[index].freeCount}
                                    className={`form-control ${
                                      !!errors.freeCount ? "is-invalid" : ""
                                    }`}
                                    onChange={(event) =>
                                      handleFormChange(
                                        index,
                                        event,
                                        item._id,
                                        "freeCount",
                                        item.billingItemCode
                                      )
                                    }
                                  />
                                </Col>
                                <Col xs={12} sm={3}>
                                  {index === 0 ? (
                                    <Form.Label>Charge Per ($)</Form.Label>
                                  ) : (
                                    <Form.Label />
                                  )}

                                  <NumericInput
                                    precision={2}
                                    step={0.1}
                                    name="ChargesPer"
                                    inputMode="numeric"
                                    strict
                                    style={false}
                                    value={inputFields[index].perCharge}
                                    className={`form-control ${
                                      !!errors.ChargesPer ? "is-invalid" : ""
                                    }`}
                                    onChange={(event) =>
                                      handleFormChange(
                                        index,
                                        event,
                                        item._id,
                                        "perCharge",
                                        item.billingItemCode
                                      )
                                    }
                                  />
                                  {/* this and condition is for basic fees can be zero so do not show error message */}
                                  {/* {inputFields[index].perCharge === 0 &&
                                  inputFields[index].billingItemName !==
                                    "basicfees" ? (
                                    <>
                                      <div
                                        className="invalid-feedback"
                                        style={{ display: "block" }}
                                      >
                                        Charge is zero, not allowed
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )} */}
                                </Col>

                                <Col xs={12} sm={3}>
                                  <Button
                                    variant="transparent"
                                    style={{ marginTop: "25px" }}
                                    onClick={(e) =>
                                      handledeleteSelectItems(item._id, index)
                                    }
                                  >
                                    <Clear className="clear" />
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          );
                        })
                      : ""}
                  </Col>
                </Row>
                <Row className="form-group pt-4 pb-4">
                  <Col>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-blue w-90 font-14 mr-3"
                      disabled={disable}
                    >
                      Save
                    </Button>
                    <Button
                      variant="primary"
                      className="btn-blue btn-outlined w-90 font-14"
                      onClick={() =>
                        history.push("/BillingModule/BillingPlansList")
                      }
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  { addBillingPlan, getAllBillingItems, getApplicationData }
)(BillingPlanForm);
